module.exports = __webpack_public_path__ + "static/media/list32.7f1ee39a.png";